import type { ReactNode } from 'react';
import { cx } from '../ui/styles';

const tones = {
  warning: 'bg-amber-100 text-amber-700',
  info: 'bg-sky-100 text-sky-700',
  calm: 'bg-emerald-100 text-emerald-700',
};

type NoticeTone = keyof typeof tones;

interface ChildNoticeProps {
  readonly icon: ReactNode;
  readonly tone?: NoticeTone;
  readonly children: ReactNode;
  readonly className?: string;
}

export function ChildNotice({ icon, tone = 'warning', children, className }: ChildNoticeProps) {
  return (
    <div
      className={cx(
        'mx-auto flex max-w-lg items-center gap-4 rounded-3xl bg-white p-5 text-left shadow-warm ring-1 ring-slate-200',
        className,
      )}
    >
      <span
        className={cx(
          'flex size-11 shrink-0 items-center justify-center rounded-2xl [&_svg]:size-6',
          tones[tone],
        )}
      >
        {icon}
      </span>
      <p className="text-lg">{children}</p>
    </div>
  );
}

interface ChildMessageProps {
  readonly icon: ReactNode;
  readonly tone?: NoticeTone;
  readonly children: ReactNode;
  readonly actions?: ReactNode;
}

export function ChildMessage({ icon, tone = 'info', children, actions }: ChildMessageProps) {
  return (
    <section className="mx-auto mt-10 max-w-lg rounded-4xl bg-white px-6 py-10 text-center shadow-warm ring-1 ring-slate-200 motion-safe:animate-rise">
      <span
        className={cx(
          'mx-auto flex size-20 items-center justify-center rounded-3xl [&_svg]:size-10',
          tones[tone],
        )}
      >
        {icon}
      </span>
      <p className="mt-6 text-2xl leading-snug font-bold">{children}</p>
      {actions ? <div className="mt-8 flex flex-wrap justify-center gap-3">{actions}</div> : null}
    </section>
  );
}
